import { appLocalStorage } from 'src/common/libs'

import { useLogoutMutation } from '../api/auth.api'
import { isCookieAuthenticationEnabled } from '../utils/isCookieAuthenticationEnabled'

import { resetAuthStore } from '@v2/domains/auth/store/auth.store'
import { useAppNavigation } from '@v2/domains/routing/hooks/useAppNavigation.hook'
import { destroyUILocalStore } from '@v2/domains/ui/store/ui.store'
import { resetUserSessionStore } from '@v2/domains/user/store/user.store'
import { useAppDispatch } from '@v2/store/hooks'

const useLogout = () => {
  const dispatch = useAppDispatch()
  const { navigateTo } = useAppNavigation()
  const [logout] = useLogoutMutation()

  return {
    mutate: async () => {
      if (isCookieAuthenticationEnabled) {
        try {
          await logout().unwrap()
        } catch {
          // Client cleanup must still complete when the server session is
          // already invalid or the logout request cannot be completed.
        }
      }

      dispatch(resetAuthStore())
      dispatch(resetUserSessionStore())
      dispatch(destroyUILocalStore())
      appLocalStorage.clear()

      navigateTo('LOGIN', {}, { includeOrgPrefix: false, hardRedirect: true })
    },
  }
}

export default useLogout
